import { render, staticRenderFns } from "./UserRoleCreateEditModal.vue?vue&type=template&id=66c2b355&scoped=true&"
import script from "./UserRoleCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./UserRoleCreateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./UserRoleCreateEditModal.vue?vue&type=style&index=0&id=66c2b355&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c2b355",
  null
  
)

/* custom blocks */
import block0 from "./UserRoleCreateEditModal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSheet } from 'vuetify/lib/components/VSheet';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VCheckbox,VDialog,VForm,VSelect,VSheet,VTextField})
